import * as React from 'react';
import classnames from 'classnames';
import MultiMixin from './MultiMixin';
const MultiPicker = (props) => {
    const { multiSelectCls, rootNativeProps, children, } = props;
    const selectedValue = props.getValue();
    const colElements = React.Children.map(children, (col, i) => {
        return React.cloneElement(col, {
            selectedValue: selectedValue[i],
            onValueChange: (...args) => props.onValueChange(i, ...args),
            onScrollChange: props.onScrollChange && ((...args) => props.onScrollChange(i, ...args)),
        });
    });
    return (<div {...rootNativeProps} className={classnames(multiSelectCls, 'cfm_multi-select')}>
      {colElements}
    </div>);
};
export default MultiMixin(MultiPicker);



// WEBPACK FOOTER //
// ./components/select-item/MultiSelect.tsx